if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        TextareaControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/card-offer', {
        // built-in attributes
        title: 'Card Offer',
        description: 'Custom Card Offer',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            image: {
                type: 'string',
                default: ''
            }, 
            alt: {
                type: 'string',
                default: ''
            }, 
            tag: {
                type: 'string',
                default: ''
            },
            price: {
                type: 'string',
                default: ''
            },
            title: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
            viewMore: {
                type: 'string',
                default: 'Saznajte više'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link,
                image,
                alt,
                tag,
                price,
                title,
                description,
                viewMore
            } = attributes;

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };

            function onSelectImage (image) {
                setAttributes({image: image.sizes.full.url});
            }

            function onAltChange(alt) {
                setAttributes({alt: alt});
            }

            function onTagChange(tag) {
                setAttributes({tag: tag});
            }

            function onPriceChange(price) {
                setAttributes({price: price});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }

            function onViewMoreChange(viewMore) {
                setAttributes({viewMore: viewMore});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ image } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                        <br />
                        <p><strong>Alt image:</strong></p>
                        <TextControl value={ alt } onChange={ onAltChange }></TextControl>
                        <br />
                        <p><strong>Enter url: (ex: /putovanja)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                        <br />
                        <p><strong>Oznaka</strong></p>
                        <TextControl value={ tag } onChange={ onTagChange }></TextControl>
                        <br />
                        <p><strong>Cijena</strong></p>
                        <TextControl value={ price } onChange={ onPriceChange }></TextControl>
                        <br />
                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                        <br />
                        <p><strong>Description</strong></p>
                        <TextareaControl value={ description } onChange={ onDescriptionChange }></TextareaControl>
                        <br />
                        <p><strong>Button</strong></p>
                        <TextControl value={ viewMore } onChange={ onViewMoreChange }></TextControl>

                    </PanelBody>
                </InspectorControls>
                ,
                <a class="card-offer d-block text-decoration-none">
                    <div class="card-img-container position-relative bg-dark shadow rounded-top overflow-hidden mb-2">
                        <img class="cover-image w-100 h-100" src={ image } alt={ alt } />
                        <div class="position-absolute top-0 start-0 bg-danger text-white fw-bold rounded-bottom-end ps-3 pe-4 py-2">
                            <RichText 
                                key="editable" 
                                tagName="span"
                                placeholder="20% FIRST MINUTE POPUST!" 
                                value={ tag }
                                onChange={ onTagChange } />
                        </div>
                        <div class="position-absolute bottom-0 end-0 bg-dark text-info lead fw-bold rounded m-2 px-3 py-2">
                            <RichText 
                                key="editable" 
                                tagName="span"
                                placeholder="od €875" 
                                value={ price }
                                onChange={ onPriceChange } />
                        </div>
                    </div>
                    <div class="bg-white shadow rounded-bottom px-4 py-3">
                        <RichText 
                            key="editable" 
                            tagName="h2"
                            className="h5 mb-1"
                            placeholder="TITLE" 
                            value={ title }
                            onChange={ onTitleChange } />
                        <RichText 
                            key="editable" 
                            tagName="p"
                            placeholder="+25 putovanja u 12 država" 
                            value={ description }
                            onChange={ onDescriptionChange } />

                        <RichText 
                            key="editable" 
                            tagName="button"
                            className="btn btn-sm btn-white p-0 text-secondary fw-bold"
                            placeholder="Saznajte više" 
                            value={ viewMore }
                            onChange={ onViewMoreChange } />
                    </div>
                </a>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                image,
                alt,
                tag,
                price,
                title,
                description,
                viewMore
            } = attributes;

            return (
                <a href={ link } class="card-offer d-block text-decoration-none">
                    <div class="card-img-container position-relative bg-dark shadow rounded-top overflow-hidden mb-2">
                        <img class="lozad cover-image w-100 h-100" data-src={ image } alt={ alt } />
                        <div class="position-absolute top-0 start-0 bg-danger text-white fw-bold rounded-bottom-end ps-3 pe-4 py-2">
                            <span>{ tag }</span>
                        </div>
                        <div class="position-absolute bottom-0 end-0 bg-dark text-info lead fw-bold rounded m-2 px-3 py-2">
                            <span>{ price }</span>
                        </div>
                    </div>
                    <div class="bg-white shadow rounded-bottom px-4 py-3">
                        <h2 class="h5 mb-1">{ title }</h2>
                        <RichText.Content 
                            tagName="p"
                            value={ description } />

                        <button class="btn btn-sm btn-white p-0 text-secondary fw-bold">{ viewMore }</button>
                    </div>
                </a>
            );
        },
    });
}